module.exports = __webpack_public_path__ + "img/arrow-right.d4a28c39.svg";